import React from 'react';
import { useDrop } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Droppable = props => {
  const dispatch = useDispatch();
  const entity = useSelector(state => state.design.entitiesState[props.entityId]);

  // eslint-disable-next-line no-unused-vars
  const [{ canDrop, isOver, item }, drop] = useDrop({
    accept: props.acceptList,
    drop: (item, monitor) => {
      const didDrop = monitor.didDrop();
      if (didDrop) {
        return;
      }
      if (props.type === 'Master') {
        item.pageId = props.pageId;
        props.onDropped(item, monitor);
      } else {
        if (props.area) {
          const data = {
            medias: {
              [props.area]: {
                resource: item.data.id,
                src: item.data.src,
                type: item.type,
              },
              style: {},
            },
          };
          dispatch(designActions.changeGridData(props.pageId, props.entityId, data));
        } else {
          dispatch(
            designActions.changeEntity(
              props.pageId,
              props.entityId,
              item.data.id,
              item.data.src,
              item.type,
            ),
          );
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    hover: (item, monitor) => { },
    collect: monitor => ({
      isOver: monitor.isOver(),
      // canDrop: monitor.canDrop(),
      item: monitor.getItem(),
    }),
  });

  // eslint-disable-next-line no-unused-vars
  // const isActive = canDrop && isOver;
  // dispatch(graphicBuilderActions.canDrop(isActive));

  let childrenProps = {};
  if (isOver) {
    childrenProps = {
      src: item.data.src,
      type: item.type,
    };
  }

  if (props.passEntityToChild) {
    childrenProps.entity = entity;
  }
  return (
    <div
      ref={drop}
      id={props.id}
      data-lock={props.dataLock}
      data-type={props.dataType}
      className={props.className}
      data-target={props.dataTarget}
      style={!props.internal ? _.get(entity, 'style.master') : {}}
      onMouseDown={props.onMouseDown}
      onMouseOver={props.onMouseOver}
    >
      {React.cloneElement(props.children, childrenProps)}
    </div>
  );
};

Droppable.propTypes = {
  pageId: PropTypes.number,
  entityId: PropTypes.any,
  type: PropTypes.string,
  children: PropTypes.any,
  acceptList: PropTypes.array,
  area: PropTypes.string,
  onDropped: PropTypes.func,
  className: PropTypes.string,
  dataTarget: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseOver: PropTypes.func,
  passEntityToChild: PropTypes.bool,
  id: PropTypes.any,
  internal: PropTypes.bool,
  dataType: PropTypes.any,
  dataLock: PropTypes.any,
};

export default Droppable;
